module.exports = __webpack_public_path__ + "img/campaign.863c7472.svg";